// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrademarkCircleFilledSvg from "@fishx/icons-svg/es/asn/TrademarkCircleFilled";
import FishxIcon from '../components/FishxIcon';

var TrademarkCircleFilled = function TrademarkCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkCircleFilledSvg
  }));
};

TrademarkCircleFilled.displayName = 'TrademarkCircleFilled';
export default React.forwardRef(TrademarkCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TrademarkCircleFilled.js
// module id = 4269
// module chunks = 0